import { labelService } from '../../helpers/services/productLabel.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_LABEL_MODULE = 'productLabel';

// define action 
export const GET_ALL_PRODUCT_LABELS = 'getAllProductLabels';
export const GET_PRODUCT_LABEL = 'getProductLabel';
export const UPDATE_PRODUCT_LABEL = 'updateProductLabel';
export const CREATE_PRODUCT_LABEL = 'createProductLabel';
export const CREATE_PRODUCT_LABEL_FASTER = 'createProductLabelFaster';
export const UPDATE_PRODUCT_LABEL_STATUS = 'updateProductLabelStatus';
export const CREATE_PRODUCT_LABEL_MULTIPLE = 'createProductLabelMultiple';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_LABELS_REQUEST = "getAllProductLabels";
const GET_PRODUCT_LABEL_REQUEST = "getProductLabel";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_LABELS]({ commit }, { filter }) {
        await labelService
            .getAllLabels(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_LABELS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_LABEL]({ commit }, { id }) {
        labelService
            .getLabel(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_LABEL_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_LABEL]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        labelService
            .updateLabel(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.productLabel')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_LABEL]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        labelService
            .createLabel(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.productLabel')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [CREATE_PRODUCT_LABEL_FASTER]({ commit, dispatch }, { data, filter }) {
        commit(REQUEST)
        try {
            await labelService.createLabel(data);

            const message = i18n.t("message.createXSuccess", [i18n.t('module.productLabel')]);
            sharedHelper.alertSuccessMessage(message);

            await dispatch(GET_ALL_PRODUCT_LABELS, { filter });
            commit(SUCCESS)
            return true; // ✅ This will be received by the caller
        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
            commit(FAILURE);

            return false; // ✅ Caller will receive this
        }
    }, 

     // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_LABEL_MULTIPLE]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        labelService
            .createLabelMultiple(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.productLabel')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_LABEL_STATUS]({ dispatch }, { filter, data }) {
        labelService
            .updateLabelStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_LABELS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if (isCloseWhenSuccess == false) {
            router.push({ name: "Product-label-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_LABELS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                product: o.product,
                file: o.image_url,
                packageSize: o.package_size,
                sizes: o.sizes,
                image: o.photo_url,
                imageBack: o.back_image_url,
                date: o.date,
                packagingMaterial: o.packaging_material,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_LABEL_REQUEST](state, data) {
        let o = data.data

        console.log(o);

        state.details = {
            uuid: o.uuid,
            name: o.name,
            product: o.product,
            file: o.image_url,
            oldFile: o.image_url,
            imageBack: o.back_image_url,
            packageSize: o.package_size,
            sizes: o.sizes,
            image: o.photo_url,
            date: o.date,
            packagingMaterial: o.packaging_material,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productID: o.product != null ? {
                value: o.product.uuid,
                text: o.product.name
            } : '',
            removedFile: [],
            displayImages: o.images,
            displayImageUrls: o.images.map(image => image.image_url), // New property
        }

    }
}


